import { render } from "./ERP_CompaniesGrid.vue?vue&type=template&id=c4458aac&scoped=true&ts=true"
import script from "./ERP_CompaniesGrid.vue?vue&type=script&lang=ts"
export * from "./ERP_CompaniesGrid.vue?vue&type=script&lang=ts"

import "./ERP_CompaniesGrid.vue?vue&type=style&index=0&id=c4458aac&scoped=true&lang=css"
import "./ERP_CompaniesGrid.vue?vue&type=style&index=1&id=c4458aac&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4458aac"]])

export default __exports__